import React, { useState, useEffect } from 'react';
import Countdown from './Countdown';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [audioProgress, setAudioProgress] = useState(0);
  const [copiedNumber, setCopiedNumber] = useState(null);
  const [activeCountry, setActiveCountry] = useState('malawi');
  const [showFullSizeImage, setShowFullSizeImage] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleAudioProgress = (e) => {
    const audio = e.target;
    const progress = (audio.currentTime / audio.duration) * 100;
    setAudioProgress(progress);
  };

  const copyToClipboard = (text, numberIndex) => {
    navigator.clipboard.writeText(text);
    setCopiedNumber(numberIndex);
    setTimeout(() => setCopiedNumber(null), 2000);
  };

  const openFullSizeImage = () => {
    setShowFullSizeImage(true);
    document.body.style.overflow = 'hidden';
  };

  const closeFullSizeImage = () => {
    setShowFullSizeImage(false);
    document.body.style.overflow = 'auto';
  };

  const malawiPaymentMethods = [
    {
      name: "Airtel Money Method 1",
      number: "255782991247",
      receiver: "Benson Anania Urio",
      code: "*211#",
      color: "from-rose-600 to-orange-500",
      textColor: "text-rose-50",
      borderColor: "border-rose-400/30",
      instructions: "Send to Tanzania via Airtel Money",
      steps: [
        "Dial *211#",
        "Select 'Send Money'",
        "Select 'Other Countries'",
        "Select 'Tanzania' → 'Airtel Tanzania'",
        "Select 'BUSINESS'",
        "Enter number: 255782991247",
        "Enter amount: 20,500 MWK",
        "Enter pin and send"
      ]
    },
    {
      name: "Airtel Money Method 2",
      number: "255696929985",
      receiver: "DORIS MAISELI",
      code: "*211#",
      color: "from-violet-600 to-purple-500",
      textColor: "text-violet-50",
      borderColor: "border-violet-400/30",
      instructions: "Quick alternative method",
      steps: [
        "Dial *211#",
        "Select 'Send Money'",
        "Select 'Other Countries'",
        "Select 'Tanzania' → 'Airtel Tanzania'",
        "Select 'BUSINESS'",
        "Enter number: 255696929985",
        "Enter amount: 20,500 MWK",
        "Enter pin and send"
      ]
    }
  ];

  const ghanaPaymentMethods = [
    {
      name: "MTN Mobile Money",
      number: "0543704715",
      receiver: "Delali Sepenu",
      code: "*170#",
      color: "from-amber-600 to-orange-500",
      textColor: "text-amber-50",
      borderColor: "border-amber-400/30",
      instructions: "Standard MTN MoMo procedure",
      steps: [
        "Dial *170#",
        "Select Option 1: 'Transfer Money'",
        "Select 5: 'Other Networks' → Choose 'Telecel'",
        "Enter number: 0543704715",
        "Confirm name: Delali Sepenu",
        "Enter amount: GHS 80",
        "Enter *reference id as your username",
        "Enter mobile pin and send"
      ]
    },
    {
      name: "Vodafone/Telecel Cash",
      number: "0543704715",
      receiver: "Delali Sepenu",
      code: "Direct Send",
      color: "from-rose-600 to-pink-500",
      textColor: "text-rose-50",
      borderColor: "border-rose-400/30",
      instructions: "Direct send for Vodafone users",
      steps: [
        "Send directly to 0543704715",
        "Enter amount: GHS 80",
        "Proceed and send payment"
      ]
    },
    {
      name: "AirtelTigo Money",
      number: "0543704715",
      receiver: "Delali Sepenu",
      code: "*110#",
      color: "from-indigo-600 to-purple-500",
      textColor: "text-indigo-50",
      borderColor: "border-indigo-400/30",
      instructions: "AirtelTigo payment method",
      steps: [
        "Dial *110#",
        "Choose 'Send Money/Cash'",
        "Select 'To Mobile Number'",
        "Select 'Other Network' → Choose 'Telecel (Vodafone)'",
        "Enter number: 0543704715",
        "Confirm name: Delali Sepenu",
        "Enter amount: GHS 80",
        "Proceed and send"
      ]
    }
  ];

  const incomeStreams = [
    "Direct Referral Bonuses",
    "Team Building Commissions", 
    "Leadership Bonuses",
    "Residual Income",
    "Performance Rewards",
    "Rank Advancement",
    "Weekly Contests",
    "Matching Bonuses",
    "Global Pool",
    "Special Incentives"
  ];

  const mentorshipNumbers = [
    { number: "+254785828526", name: "WhatsApp Mentor" },
    { number: "+254713691451", name: "Alternative WhatsApp" }
  ];

  const countryData = {
    malawi: {
      name: "Malawi",
      flag: "🇲🇼",
      currency: "MWK",
      activationFee: "20,500",
      dailyEarnings: "50,000+",
      paymentLink: "https://vumaqash.com/user/malawipay.php",
      color: "from-rose-600 to-emerald-500",
      paymentMethods: malawiPaymentMethods,
      helpline: "+254778664136",
      requirements: "payment screenshot, full names, number, username and email address"
    },
    ghana: {
      name: "Ghana", 
      flag: "🇬🇭",
      currency: "GHS",
      activationFee: "80",
      dailyEarnings: "100+",
      paymentLink: "https://vumaqash.com/user/ghanapay.php",
      color: "from-amber-500 via-rose-500 to-emerald-500",
      paymentMethods: ghanaPaymentMethods,
      helpline: "+254788778206",
      requirements: "payment screenshot, username, full momo names and mobile number"
    }
  };

  const currentCountry = countryData[activeCountry];

  return (
    <>
      <section
        className={`relative min-h-screen py-8 md:py-16 lg:py-20 overflow-hidden bg-gradient-to-br from-slate-900 via-gray-800 to-zinc-900 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}
        id="home"
      >
        {/* Enhanced Animated Background */}
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1740&q=80')] bg-cover bg-center opacity-15"></div>
        
        {/* Dynamic Floating Particles */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-cyan-400/25 rounded-full -translate-y-1/3 translate-x-1/3 blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-400/25 rounded-full translate-y-1/3 -translate-x-1/3 blur-3xl animate-pulse delay-700"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-amber-400/15 rounded-full blur-3xl animate-pulse delay-300"></div>

        {/* Subtle Grid Overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:60px_60px]"></div>

        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Main Intro Section */}
            <div className="space-y-8 text-center lg:text-left">
              {/* Country Selector */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <button
                  onClick={() => setActiveCountry('malawi')}
                  className={`px-6 py-3 rounded-full font-bold transition-all duration-300 font-poppins ${
                    activeCountry === 'malawi'
                      ? 'bg-gradient-to-r from-rose-600 to-emerald-500 text-white shadow-2xl shadow-emerald-500/40 scale-105'
                      : 'bg-slate-700 text-slate-200 hover:bg-slate-600 hover:scale-105 border border-slate-500'
                  }`}
                >
                  🇲🇼 Malawi
                </button>
                <button
                  onClick={() => setActiveCountry('ghana')}
                  className={`px-6 py-3 rounded-full font-bold transition-all duration-300 font-poppins ${
                    activeCountry === 'ghana'
                      ? 'bg-gradient-to-r from-amber-500 via-rose-500 to-emerald-500 text-white shadow-2xl shadow-amber-500/40 scale-105'
                      : 'bg-slate-700 text-slate-200 hover:bg-slate-600 hover:scale-105 border border-slate-500'
                  }`}
                >
                  🇬🇭 Ghana
                </button>
              </div>

              {/* Launch Badge */}
              <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-emerald-600 to-lime-500 text-white px-6 py-3 rounded-full text-sm font-bold border border-emerald-400/40 shadow-2xl shadow-emerald-500/40 transform hover:scale-105 transition-all duration-300 cursor-pointer group font-poppins">
                <span className="h-2 w-2 bg-amber-400 rounded-full animate-ping group-hover:animate-none"></span>
                <span className="font-bold tracking-wide">VumaQash {currentCountry.name} • Launched</span>
                <span className="h-2 w-2 bg-amber-400 rounded-full animate-ping group-hover:animate-none animation-delay-1000"></span>
              </div>

              {/* Main Heading */}
              <div className="space-y-6">
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight font-poppins">
                  <span className="bg-gradient-to-r from-amber-400 via-lime-400 to-emerald-400 bg-clip-text text-transparent animate-gradient tracking-tight">
                    Start Earning Daily
                  </span>
                  <span className="text-cyan-300 block mt-4 text-2xl md:text-3xl lg:text-4xl font-semibold font-roboto tracking-wide">
                    {currentCountry.currency} {currentCountry.dailyEarnings} Daily • 10 Income Streams
                  </span>
                </h1>

                {/* Income Streams Grid */}
                <div className="grid grid-cols-2 md:grid-cols-5 gap-2 max-w-2xl">
                  {incomeStreams.map((stream, index) => (
                    <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-2 border border-white/20 text-xs text-center text-slate-100 hover:bg-white/20 hover:scale-105 transition-all duration-300 font-roboto">
                      {stream}
                    </div>
                  ))}
                </div>
              </div>

              {/* Description */}
              <div className="space-y-4 max-w-xl mx-auto lg:mx-0">
                <p className="text-lg text-slate-200 leading-relaxed font-roboto">
                  Complete guide to join VumaQash in {currentCountry.name}. 
                  <strong className="text-amber-300 font-semibold"> I'll be your mentor</strong> for faster activation and growth!
                </p>
                
                <div className="bg-rose-500/20 border border-rose-500/40 rounded-xl p-4">
                  <p className="text-rose-300 font-semibold text-base flex items-center justify-center lg:justify-start space-x-2 font-poppins">
                    <span className="text-xl">⚠️</span>
                    <span>Text me on Telegram FIRST, then JOIN WhatsApp Group for community!</span>
                  </p>
                </div>
              </div>

              {/* Main CTA Buttons */}
              <div className="space-y-6">
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://www.vumaqash.com/user/register.php?ref=CLEOPHAS"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-3 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-orange-500 hover:to-rose-600 text-white font-bold px-6 py-4 rounded-full shadow-2xl shadow-amber-500/40 transition-all transform hover:scale-105 hover:shadow-amber-500/60 duration-300 text-base group flex-1 font-poppins"
                  >
                    <span className="text-xl">📝</span>
                    <span>Register Now</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </a>

                  <a
                    href={currentCountry.paymentLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-3 bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white font-bold px-6 py-4 rounded-full shadow-2xl shadow-emerald-500/40 transition-all transform hover:scale-105 hover:shadow-emerald-500/60 duration-300 text-base group flex-1 font-poppins"
                  >
                    <span className="text-xl">💳</span>
                    <span>Auto Payment</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                </div>

                {/* Social Media Buttons */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <a
                    href="https://chat.whatsapp.com/KBmtWKO6vEC9XLGdDpUTmJ"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold px-4 py-3 rounded-full shadow-lg shadow-emerald-500/30 transition-all hover:scale-105 duration-300 group font-poppins"
                  >
                    <span className="text-lg">💬</span>
                    <span className="text-sm">Join WhatsApp Group</span>
                  </a>

                  <a
                    href="https://t.me/CLEOPHAS_KOECH"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold px-4 py-3 rounded-full shadow-lg shadow-blue-500/30 transition-all hover:scale-105 duration-300 group font-poppins"
                  >
                    <span className="text-lg">📢</span>
                    <span className="text-sm">Telegram Channel</span>
                  </a>

                  <a
                    href="https://t.me/CLEOPHAS_MWK"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-violet-500 to-purple-500 text-white font-semibold px-4 py-3 rounded-full shadow-lg shadow-violet-500/30 transition-all hover:scale-105 duration-300 group font-poppins"
                  >
                    <span className="text-lg">👤</span>
                    <span className="text-sm">Message Me (FAST)</span>
                  </a>
                </div>

                {/* Countdown Timer */}
                <div className="max-w-md mx-auto lg:mx-0">
                  <Countdown />
                </div>
              </div>
            </div>

            {/* Step-by-step Guide Section */}
            <div className="space-y-6 bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl border border-emerald-500/30 rounded-2xl p-6 shadow-2xl shadow-emerald-500/20 relative overflow-hidden">
              {/* Decorative Corners */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-emerald-500/15 rounded-bl-full"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-cyan-500/15 rounded-tr-full"></div>

              <h2 className="text-3xl md:text-4xl font-bold text-emerald-300 relative font-poppins tracking-wide">
                {currentCountry.name} Registration Guide
                <div className="absolute bottom-0 left-0 w-20 h-1 bg-gradient-to-r from-emerald-400 to-cyan-400 rounded-full"></div>
              </h2>

              {/* Steps Card */}
              <div className="bg-black/40 backdrop-blur-sm rounded-xl border border-slate-400/20 p-4 space-y-4 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-amber-400 to-emerald-400"></div>
                
                <h3 className="text-lg font-bold text-amber-300 flex items-center space-x-2 font-poppins">
                  <span className="text-xl">📝</span>
                  <span>Step-by-Step Process</span>
                </h3>
                
                <ol className="space-y-3 text-slate-300 text-sm font-roboto">
                  {[
                    "Register using my referral link above",
                    "Watch video tutorial & screenshot guide below",
                    "Choose automatic payment OR manual methods",
                    `Pay ${currentCountry.currency} ${currentCountry.activationFee} activation fee`,
                    "📱 Text me on Telegram for FAST activation & mentorship",
                    "💬 JOIN WhatsApp Group - This is the BEST thing for community!"
                  ].map((step, index) => (
                    <li key={index} className="flex items-start space-x-3 group">
                      <span className="flex-shrink-0 w-6 h-6 bg-gradient-to-r from-amber-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-bold text-xs group-hover:scale-110 transition-transform">
                        {index + 1}
                      </span>
                      <span className="pt-0.5">{step}</span>
                    </li>
                  ))}
                </ol>
                
                <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3">
                  <p className="text-blue-300 text-xs font-semibold flex items-center space-x-2 font-poppins">
                    <span>🚨 IMPORTANT</span>
                    <span>📢 Important Update

My main WhatsApp (+254 115 647 545) is temporarily unavailable.

✅ Step 1: First, activate your account.
✅ Step 2: If you had already reached me, please join our official WhatsApp group.

🚀 For immediate help, kindly use Telegram at +254 713 691 451.
⚠️ Important Security Notice:

I will never text you first on Telegram.

Always message me directly for assistance.

Beware of fake accounts — only trust the contact above.

👉 Stay safe and connected!</span>
                  </p>
                </div>
              </div>

              {/* Media Section - Registration Guides */}
              <div className="space-y-4">
                <h3 className="text-lg font-bold text-amber-300 font-poppins">🎬 Registration Guides</h3>
                
                {/* YouTube Video */}
                <div className="bg-black/40 rounded-xl border border-slate-400/20 p-4 space-y-3">
                  <h4 className="text-md font-bold text-cyan-300 flex items-center space-x-2 font-poppins">
                    <span className="text-lg">🎥</span>
                    <span>Video Tutorial</span>
                  </h4>
                  <a
                    href="https://youtu.be/tr_gjnKhJlA?si=yaCRDcrsyVMx6zfi"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block bg-gradient-to-r from-rose-500 to-orange-500 text-white font-bold px-4 py-3 rounded-lg text-center shadow-lg hover:scale-105 transition-all duration-300 group font-poppins"
                  >
                    <span className="flex items-center justify-center space-x-2">
                      <span className="text-lg">▶️</span>
                      <span>Watch Registration Video Guide</span>
                      <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </span>
                  </a>
                </div>

                {/* Screenshot Guide */}
                <div className="bg-black/40 rounded-xl border border-slate-400/20 p-4 space-y-3">
                  <h4 className="text-md font-bold text-cyan-300 flex items-center space-x-2 font-poppins">
                    <span className="text-lg">🖼️</span>
                    <span>Screenshot Guide</span>
                  </h4>
                  <div 
                    className="relative group cursor-pointer"
                    onClick={openFullSizeImage}
                  >
                    <img
                      src="/registration-screenshot.png"
                      alt="Step-by-step registration screenshot guide showing how to create VumaQash account"
                      className="rounded-lg border border-slate-400/20 shadow-lg w-full group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100">
                      <span className="text-white font-bold text-sm bg-black/70 px-3 py-2 rounded-lg font-poppins">Click to view full size</span>
                    </div>
                  </div>
                  <p className="text-slate-300 text-xs text-center font-roboto">
                    Follow these steps to create your account correctly
                  </p>
                </div>

                {/* Audio Summary - EXACT COPY FROM WORKING CODE */}
                <div className="bg-white/5 rounded-xl border border-white/10 p-4 space-y-3">
                  <h4 className="text-md font-bold text-cyan-300 flex items-center space-x-2">
                    <span className="text-lg">🎧</span>
                    <span>Quick Audio Summary (3 mins)</span>
                  </h4>
                  <div className="space-y-2">
                    <audio 
                      controls 
                      className="w-full rounded-lg"
                      onTimeUpdate={handleAudioProgress}
                    >
                      <source src="/summary.ogg" type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                    <div className="w-full bg-gray-700 rounded-full h-2">
                      <div 
                        className="bg-gradient-to-r from-green-400 to-cyan-400 h-2 rounded-full transition-all duration-100"
                        style={{ width: `${audioProgress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* WhatsApp Group Emphasis */}
                <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-xl p-4 space-y-3">
                  <h4 className="text-md font-bold text-emerald-300 flex items-center space-x-2 font-poppins">
                    <span className="text-lg">💬</span>
                    <span>Join Our Community</span>
                  </h4>
                  <div className="text-center space-y-2">
                    <p className="text-slate-200 text-sm font-roboto">
                      <strong className="text-emerald-300">After texting me on Telegram, JOIN our WhatsApp Group!</strong>
                    </p>
                    <p className="text-slate-300 text-xs font-roboto">
                      Get daily updates, success stories, and connect with other members
                    </p>
                    <a
                      href="https://chat.whatsapp.com/KBmtWKO6vEC9XLGdDpUTmJ"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold px-4 py-2 rounded-lg shadow-lg hover:scale-105 transition-all duration-300 group font-poppins mt-2"
                    >
                      <span className="text-lg">💬</span>
                      <span>Join WhatsApp Group Now</span>
                      <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="space-y-4">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                  <h3 className="text-lg font-bold text-amber-300 font-poppins">💳 Payment Methods</h3>
                  <div className="flex gap-2">
                    <a
                      href={currentCountry.paymentLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-3 py-2 rounded-full hover:scale-105 transition-transform font-poppins"
                    >
                      Auto Payment
                    </a>
                    <div className="text-xs bg-blue-500/20 text-blue-300 px-3 py-2 rounded-full border border-blue-500/30 font-poppins">
                      Manual Methods
                    </div>
                  </div>
                </div>
                
                <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3 mb-3">
                  <p className="text-blue-300 text-xs font-semibold flex items-center space-x-2 font-poppins">
                    <span>🚀</span>
                    <span>Use AUTO payment for instant activation! Manual takes 5-15 min.</span>
                  </p>
                </div>

                <div className="grid gap-3">
                  {currentCountry.paymentMethods.map((method, index) => (
                    <div key={index} className={`bg-gradient-to-r ${method.color} rounded-lg p-4 ${method.textColor} shadow-lg hover:scale-105 transition-transform border ${method.borderColor}`}>
                      <div className="space-y-2">
                        <div className="flex justify-between items-start">
                          <div className="flex-1">
                            <p className="font-bold text-base font-poppins">{method.name}</p>
                            <p className="text-sm opacity-90 font-roboto">To: {method.receiver}</p>
                            <p className="text-sm opacity-90 font-roboto">Number: {method.number}</p>
                            {method.code && <p className="text-sm opacity-90 font-roboto">Code: {method.code}</p>}
                            <p className="text-xs opacity-90 mt-1 font-roboto">{method.instructions}</p>
                          </div>
                          <button
                            onClick={() => copyToClipboard(method.number, index)}
                            className="bg-white/20 hover:bg-white/30 rounded px-2 py-1 text-xs font-semibold transition-colors ml-2 font-poppins"
                          >
                            {copiedNumber === index ? '✅' : '📋'}
                          </button>
                        </div>
                        
                        <div className="bg-black/20 rounded p-2">
                          <p className="text-xs font-semibold mb-1 font-poppins">Steps:</p>
                          <ol className="text-xs space-y-1 font-roboto">
                            {method.steps.map((step, stepIndex) => (
                              <li key={stepIndex} className="flex items-start space-x-1">
                                <span className="text-xs">{stepIndex + 1}.</span>
                                <span>{step}</span>
                              </li>
                            ))}
                          </ol>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* After Payment Instructions */}
                <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-3">
                  <p className="text-amber-300 text-xs font-semibold font-poppins">
                    📨 After payment, send to helpline: {currentCountry.requirements}
                  </p>
                </div>
              </div>

              {/* Mentorship Contacts */}
              <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-slate-400/20 p-4 space-y-4">
                <h3 className="text-lg font-bold text-amber-300 flex items-center space-x-2 font-poppins">
                  <span className="text-xl">👥</span>
                  <span>Mentorship & Activation</span>
                </h3>
                
                <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-3 mb-3">
                  <p className="text-emerald-300 text-xs font-semibold text-center font-poppins">
                    ✅ STEP 1: Text me on Telegram for FAST activation<br/>
                    ✅ STEP 2: JOIN WhatsApp Group - This is the BEST thing!
                  </p>
                </div>

                <div className="grid gap-2">
                  {/* Telegram Contact - PRIMARY */}
                  <div className="space-y-2">
                    <p className="text-cyan-300 font-semibold text-xs font-poppins">📱 Telegram (RECOMMENDED - Fast Response):</p>
                    <a
                      href="https://t.me/CLEOPHAS_MWK"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold px-4 py-3 rounded-lg text-center shadow-lg hover:scale-105 transition-all duration-300 group font-poppins"
                    >
                      <span className="flex items-center justify-center space-x-2">
                        <span className="text-lg">⚡</span>
                        <span>
                          <span className="block text-xs opacity-90">Cleophas (Primary Contact)</span>
                          <span className="block text-sm">@CLEOPHAS_MWK</span>
                        </span>
                        <span className="group-hover:translate-x-1 transition-transform">→</span>
                      </span>
                    </a>
                    <p className="text-emerald-300 text-xs text-center font-roboto">
                      ✅ Active 24/7 • Instant Replies • Best for Activation
                    </p>
                  </div>

                  {/* WhatsApp Group Emphasis */}
                  <div className="space-y-2">
                    <p className="text-emerald-300 font-semibold text-xs font-poppins">💬 WhatsApp Group (MUST JOIN):</p>
                    <a
                      href="https://chat.whatsapp.com/KBmtWKO6vEC9XLGdDpUTmJ"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-semibold px-4 py-3 rounded-lg text-center shadow-lg hover:scale-105 transition-all duration-300 group font-poppins"
                    >
                      <span className="flex items-center justify-center space-x-2">
                        <span className="text-lg">💬</span>
                        <span>
                          <span className="block text-xs opacity-90">Join Our Community</span>
                          <span className="block text-sm">Best for Updates & Support</span>
                        </span>
                        <span className="group-hover:translate-x-1 transition-transform">→</span>
                      </span>
                    </a>
                    <p className="text-amber-300 text-xs text-center font-roboto">
                      🏆 This is the BEST thing after activation - Join our growing community!
                    </p>
                  </div>
                </div>

                <div className="bg-rose-500/10 border border-rose-500/30 rounded-lg p-2">
                  <p className="text-rose-300 text-xs font-semibold text-center font-poppins">
                    ⚠️ Text Telegram first for activation, then JOIN WhatsApp Group for community!
                  </p>
                </div>
              </div>

              {/* Success Indicator */}
              <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-xl p-4 text-center">
                <p className="text-emerald-300 font-semibold text-sm font-poppins">
                  ✅ 4,296+ Members Activated • 98% Success Rate
                </p>
                <p className="text-emerald-200 text-xs mt-1 font-roboto">
                  Start earning {currentCountry.currency} {currentCountry.dailyEarnings} daily with my mentorship!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Full Size Image Modal */}
      {showFullSizeImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-lg flex items-center justify-center p-4"
          onClick={closeFullSizeImage}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              className="absolute -top-12 right-0 text-white text-2xl bg-rose-500 hover:bg-rose-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors z-10"
              onClick={closeFullSizeImage}
            >
              ✕
            </button>
            <img
              src="/registration-screenshot.png"
              alt="Full size registration guide"
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
            <div className="text-white text-center mt-4">
              <p className="text-sm font-roboto">Scroll to see more details • Click anywhere to close</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;